
import listStyle from "../../List.module.scss";
import type { ListProps } from "../../types";
import { NoContent, Row, type RowProps } from "../Row/Row";


type Props = Pick<ListProps, "link" | "sliderChildren" | "rows" | "headers" | "rowClass" | "rowContainerClass" | "onClick" | "noLink"> &
{
    //elementRef: React.LegacyRef<HTMLElement>;
    onMenu: (id: string, event: any, params: Record<string, any>) => void;

} & Pick<RowProps, "hasMenu">;


export const RowContainer: React.FC<Props> = ({
    link,
    rows,
    headers,
    rowClass,
    rowContainerClass,
    onMenu,
    hasMenu,
    //elementRef
}) =>
{

    return <section
        className={`${listStyle.rowContainer} ${rowContainerClass}`} >
        {

            !rows || !rows.length ? <NoContent /> :
                rows.map((row: any, index: number) =>
                {
                    return <Row
                        key={index}
                        headers={headers}
                        row={row}
                        rowClass={rowClass}
                        link={link}
                        index={index}
                        onMenu={onMenu}
                        hasMenu={hasMenu}
                    />;
                })
        }
    </section>;

};
